import { SetSortController } from 'src/hooks/use-sort-controller';
import { SortOrder } from 'src/types/enum/sort-order';

export const handleUpdateSort = (
  setSortController: SetSortController,
  handleChangeSort: (sort: string[]) => void,
  columnId: string,
) => {
  setSortController(prev => {
    handleChangeSort([
      `${columnId}:${
        prev.sortOrder === SortOrder.ASC ? SortOrder.DESC : SortOrder.ASC
      }`,
    ]);
    return {
      ...prev,
      sortOrder:
        prev.sortOrder === SortOrder.ASC ? SortOrder.DESC : SortOrder.ASC,
      sortBy: columnId,
    };
  });
};
